import { useEffect, useState } from "react"
import { useCustomQuery } from "./useCustomQuery"

const usePaymentMethods = () => {
  const [paymentMethods, setPaymentMethods] = useState([])
  const {
    data: paymentMethodsResponse,
    isLoading,
    isError,
    isFetching,
  } = useCustomQuery(["settings"], "settings?filter[key]=payment")

  useEffect(() => {
    if (paymentMethodsResponse?.data) {
      setPaymentMethods(paymentMethodsResponse.data)
    }
  }, [paymentMethodsResponse])
  return {
    paymentMethods,
    isLoading,
    isError,
    isFetching,
    setPaymentMethods,
  }
}

export default usePaymentMethods
